import {
    debounceAsync,
    RelodeApiError,
    validateEmail,
    validatePhone,
} from "@relode/core";
import { ClientValidationRequest } from "../../../shared/backend/controllers/settings/clientValidationRequest";
import { profileService } from "../../../shared/backend/controllers/settings/profileService";
import memoizee from "memoizee";
import * as Yup from "yup";

const validatePhoneEmail = async (phoneNumber?: string, email?: string) => {
    if (!phoneNumber || !email) return true;
    try {
        const request: ClientValidationRequest = {
            email: email,
            phoneNumber: phoneNumber,
        };
        await profileService.validateProfile(request);
        return true;
    } catch (error) {
        if (error instanceof RelodeApiError) {
            if (error.isAbort()) return;
            if (error.isClientError()) return error;
        }
        throw error;
    }
};
const memoPhoneEmail = memoizee(validatePhoneEmail, {
    promise: true,
    length: 3,
    max: 1,
});
export const debouncePhoneEmail = debounceAsync(memoPhoneEmail, 500);

export const createContactSchema = () =>
    Yup.object()
        .shape({
            firstName: Yup.string().required("first name is required"),
            lastName: Yup.string().required("last name is required"),
            email: Yup.string()
                .test({
                    name: "asyncEmail",
                    message: "invalid email",
                    // tslint:disable-next-line object-literal-shorthand only-arrow-functions
                    test: function (value: string) {
                        return validateEmail(value);
                    },
                })
                .nullable(true),
        })
        .test({
            name: "asyncEmailPhone",
            message: "invalid email or phone",
            // tslint:disable-next-line object-literal-shorthand only-arrow-functions
            test: async function (value: {
                phoneNumber?: string;
                email?: string;
            }) {
                // validate only if one of the values changed
                const apiValidationResult = await debouncePhoneEmail(
                    value.phoneNumber,
                    value.email
                );
                if (apiValidationResult !== true) {
                    if (
                        apiValidationResult?.validationErrors?.length ??
                        0 > 0
                    ) {
                        // eslint-disable-next-line @typescript-eslint/no-this-alias
                        const yupThis = this;
                        const createErrorAggregate = this.createError({
                            path: "",
                            message: "",
                        });
                        apiValidationResult.validationErrors.forEach(
                            validationError => {
                                createErrorAggregate.inner.push(
                                    yupThis.createError({
                                        path: validationError.field,
                                        message: validationError.messages.join(
                                            " "
                                        ),
                                    })
                                );
                            }
                        );
                        return createErrorAggregate;
                    }
                }
                return true;
            },
        });
